<template>
  <div class="wrapper" v-loading.fullscreen="loading">
    <div class="shop-container">
      <div class="nav">
        <router-link to="home">{{$t('home')}}</router-link>
        <span>></span>
        <span>{{$t('articleCenter')}}</span>
      </div>
      <div class="main">
        <div class="l">
          <div class="article-right">
            <div class="hot box">
                <h4>
                    <strong>{{$t('informationClassify')}}</strong>
                </h4>
                <ul>
                    <li v-for="item in classifyList.slice(0, classifyList.length - sliceNum)" :key="item.id" style="cursor: pointer"> <div @click="goClass(item)">{{item.type_name}}</div> </li>
                    <li class="more" @click="more" v-if="sliceNum != 0">{{$t('see')}}{{$t('more')}}</li>
                </ul>
            </div>
            <div class="choice box">
                 <h4>
                    <strong>{{$t('trendingToday')}}</strong>
                </h4>
                <ul class="article">
                    <li  :key="index"  v-for="(item, index) in todayList"> 
                        <em  :class="{active: index < 3 }">{{index + 1}}</em>

                        <div @click="changeId(item.id)"  class="link">{{item.title}}</div>
                    </li>
                </ul>
            </div>
            <div class="academy box" style="display:none;">
                <h4>
                    <!-- 热门视频 -->
                    <strong>{{$t('hot')}}{{$t('video')}}</strong>
                    <router-link to="/article/index" class="link">{{$t('more')}}></router-link>
                </h4>
                <ul>
                    <li v-for="item in hotVideoList" :key="item.id"> 
                        <router-link :to="{name: 'videodetail', params: {videoId: item.id} }" class="link">
                            <img :src="item.cover" alt="">
                            <div>{{item.title}}</div>
                        </router-link>
                    </li>
                </ul>
            </div>
          </div>
        </div>
        <div class="r">
          <div class="bgw">
            <template v-if="showDetail">
              <div class="article-nav">
                <div v-for="(item,index) in detail.article_type" :key="index">
                  <div v-for="(father,key) in item.father" :key="key">
                    <span class="artlink">{{father.type_name}}</span> >
                    <a href="javascript:;" class="artlink" @click="getArticleList(item.id)">{{item.type_name}}</a>
                  </div>
                </div>
              </div>
              <div class="top-head">
                {{detail.title}}
                <div class="info">
                  <span>{{$t('read')}}
                    <img src="../../assets/icon/yuedu.png" alt=""> {{detail.pv}}
                  </span>
                  <span>{{$t('Posted')}}
                    <img src="../../assets/icon/shijian.png" alt=""> {{detail.ctime}}
                  </span>
                </div>
              </div>
              <template>
                <div class="editer-box" v-html="detail.content" style="line-height:20px;"></div>
              </template>
            </template>
            <template v-else>
              <ul class="art-list">
                <li v-for="(item,index) in articleList" :key="index">
                  <div class="media">
                    <div class="media-left">
                      <a href="javascript:;" @click="getArticleDetail(item.id)">
                        <img :src="item.cover" alt="">
                      </a>
                    </div>
                    <div class="media-body">
                      <a href="javascript:;" @click="getArticleDetail(item.id)">
                        <h4>{{item.title}}</h4>
                      </a>
                      <div class="des">
                        {{item.brief}}
                      </div>
                      <div class="info">
                        <span>{{$t('read')}}
                          <img src="../../assets/icon/yuedu.png" alt=""> {{item.pv}}
                        </span>
                        <span>{{$t('releaseDate')}}
                          <img src="../../assets/icon/shijian.png" alt=""> {{newTime(item.ctime)}}
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore" v-if="totalPage>1"></Pagination>
            </template>
          </div>
          <div style="" class="next-article">
            <div class="up" v-if="detail.up && detail.up.id" @click="changeId(detail.up.id)">
              {{$t('previous')}}: <span>{{detail.up.title}}</span>
            </div>
            <div class="next"  v-if="detail.down && detail.down.id"  @click="changeId(detail.down.id)">
              {{$t('nextArticle')}}: <span>{{detail.down.title}}</span>
            </div>
          </div>


          <!-- 评论 -->

          <div class="comment-list">

            <div class="none-comment">{{$t("comment")}}</div>
            <div class="comment-list-item"  v-for="item in commentlist" :key="item.id">
              <div class="reply_list_img">
                <img :src="item.user.avatar" alt="">
              </div>
              <div class="reply_list_con">
                <div class="auth_msg clearfix"><i>{{item.user.nickname}}</i> {{$t('Posted')}}：{{item.ctime}}</div>
                <div class="editer-box" v-html="item.content">{{item.content}}</div>
              </div>
            </div>
          </div>



          <div class="replay-action">
            <div class="comment-list-item" >
              <div class="reply_list_img">
                <img src="http://bpic.588ku.com/element_origin_min_pic/18/06/10/d52f4a4979784dabb9583c1e9d7212d0.jpg" alt="">
              </div>
              <div class="reply_list_con">
                <el-input  type="textarea" rows="6" :placeholder="$t('pleaseEnterContent')"  v-model="content">  </el-input>
                <el-button @click="commentAction">{{$t('reply')}}</el-button>
              </div>
            </div>
          </div>



        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination.vue'
export default {
  inject: ['reload'],
  name: 'Center',
  components: { Pagination },
  props: {},
  data() {
    return {
      list: [],
      page: 1,
      limit: 10,
      articleList: [],
      detail: {},
      totalPage: 0,
      showDetail: false,
      artClassId: '',
      hotList: [],
      artId: 0,
      sliceNum: 0,
      articleInfo:{},
      classifyList: [],
      todayList: [],
      form: {
          page: 1,
          limit: 10,
          where: {
              is_hot: 1
          }
      },
      hotVideoList: [],
      commentlist: [], // 评论列表
      content: '',
      loading: false
    }
  },
  computed: {
    newTime() {
      return time => {
        let ctime = time.split(' ')
        return ctime[0]
      }
    }
  },
  methods: {
      // 评论操作
      commentAction() {
        const _this = this
        if(this.content.trim().length == 0) {
          this.$message({
            message: _this.$t('pleaseEnterContent'),
            type: 'warning'
          })
          return
        }
        this.$api.courseevaluate({
          news_id: this.artId,
          content: this.content
        }).then(res =>{
          if(res.status) {
            this.$message({
              //message: res.msg,
              message: 'Successfully',
              type: 'success'
            })
            _this.content = ''
            _this.comment()
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
        })
      },
      //评论列表 
      comment() {
        this.$api.newsgetcoursecomment({...this.commentForm, news_id: this.artId}).then(res => {
          if(res.status) {
            this.commentlist = res.data.list
          }
        })
      },
     // 今日推荐
      today() {
          let form = {
              where: JSON.stringify({is_rec : 1})
          }
          this.$api.newgetlist(form).then(res => {
              if(res.status) {
                  this.todayList = res.data.list
              }
          })
      },
    changeId(id) {
        this.$router.push({
            path: '/article/detail',
            query: {
                article_id: id
            }
        })
        this.reload()
    },
    // 跳转分类页面
    goClass(item) {
        this.$router.push({
            path: '/article/index',
            query: {
                id: item.id,
                name: item.type_name
            }
        })
    },
    more() {
      this.sliceNum = 0
    },
    lookType(nav) {
      this.artClassId = nav.id
      this.getArticleList(nav.id)
    },
    handOrderMore(val) {  
      this.page = val
      this.getArticleList(this.artId)
    },
    //获取分类列表
    getArticleList(id) {
      let data = {
        type_id: id || this.artClassId,
        page: this.page,
        limit: this.limit
      }
      // this.$router.replace({
      //   path: '/help',
      //   query: {
      //     type_id: id
      //   }
      // })
      this.$api.articleList(data).then(res => {
        if (res.status) {
          this.articleList = res.data.list
          this.totalPage = Math.ceil(
            Number(res.data.count) / Number(this.limit)
          )
          // this.showDetail = false
        }
      })
    },
    //获取文章详情
    getArticleDetail(id) {
      let data = {
        article_id: id
      }
      this.$api.articleInfo(data).then(res => {
       
        if (res.status) {
          this.detail = res.data
          this.artClassId = res.data.article_type[0].id
          this.showDetail = true
          // this.$router.replace({
          //   path: '/help',
          //   query: {
          //     article_id: id
          //   }
          // })
        } else {
          this.$msg(res.msg, 'error')
        }
      })
    },
    // 获取文章所有分类
    getArticleNav() {
      this.$api.articleTypeList().then(res => {
        if (res.status) {
          this.list = res.data.list
        }
      })
    },
    // 获取推荐
    getRecommend() {
      this.$api.articleRecommend().then(res => {
       
        if (res.status) {
          this.hotList = res.data.hot
        }
      })
    },
    init() {
      this.loading = true

      this.$api.newgetdetail({id: this.artId}).then(res => {
        setTimeout(() =>{
          this.loading = false
        }, 500)
        if(res.status) {
          this.detail = res.data
          this.showDetail = true
        }
      })
    },
    // 文章分类
    classify() {
        this.$api.getnewstype().then(res => {
            if(res.status) {
                this.classifyList = res.data.list
            }
        })
    },
    initParams() {
        let copy = JSON.parse(JSON.stringify(this.form))
        copy.where = JSON.stringify(copy.where)
        return copy
    },
    hotVideo() {
      let params = this.initParams()
      this.$api.courseGetlist(params).then( res => {
          this.hotVideoList = res.data.list
          // console.log('hotVideoList', res.data.list)
      })
    }
  },
  created() {
    let query = this.$route.query
    this.artId = query.article_id
    this.init()
    this.classify()
    this.today()
    this.hotVideo()
    this.comment()
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.next-article {
  background: #fff; 
  padding: 20px;
  font-size: 14px;
  overflow: hidden;
  span {
    cursor: pointer;
    color: #e7442f;
    font-size: 12px;
  }
  .up {
    float: left;
  }
  .next {
    float: left;
  }
}
.wrapper {
  .nav {
    @include line-height(40px);
    font-size: 12px;
    span {
      padding: 0 4px;
      font-size: #757575;
    }
    a:hover {
      color: #000;
    }
  }
  .main {
    display: flex;
    margin-bottom: 20px;
    flex-direction: row-reverse;
    .l {
      width: 300px;
      margin-left: 20px;
      // padding: 40px 0;
      .article {
        padding-left: 20px;
        img {
          height: 20px;
          vertical-align: bottom;
        }
        h2 {
          font-size: 17px;
          display: inline-block;
        }
      }

      .list-wrap {
        margin-bottom: 20px;

        .classify {
          padding-left: 40px;
          img {
            width: 20px;
            vertical-align: middle;
          }
          .title {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            color: #333;
          }
        }

        ul {
          padding-left: 20px;
          li {
            padding-left: 48px;
            height: 32px;
            line-height: 32px;
            color: #757575;
            cursor: pointer;
            &.active {
              color: $theme-color;
            }
            a:hover {
              color: $theme-color;
            }
            a.router-link-active {
              color: $theme-color;
            }
          }
        }
      }
      .xian {
        border-top: 1px solid #ccc;
        width: 190px;
        text-align: center;
        margin-left: 25px;
        margin-bottom: 20px;
      }
      .recommend {
        padding: 10px;
        .title {
          // font-size: 17px;
          // color: #555;
          img {
            height: 20px;
            vertical-align: bottom;
          }
          h2 {
            font-size: 17px;
            display: inline-block;
          }
        }
        .reList {
          margin-top: 10px;
          list-style: none;
          color: rgb(85, 85, 85);
          border: 1px solid #e4eaec;
          border-radius: 4px;
          cursor: pointer;
          .reItem {
            padding: 10px 10px 10px 15px;
            white-space: normal;
            word-break: break-all;
            word-wrap: break-word;
            display: flex;
            .recommendTitle {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }
            img {
              width: 20px;
              vertical-align: middle;
            }
            span {
             
              line-height: 20px;
            }
            .title {
              white-space: nowrap;
              overflow:hidden; 
              text-overflow:ellipsis;
              // display:-webkit-box; 
              // -webkit-box-orient:vertical;
              // -webkit-line-clamp:2;
            }
          }
        }
      }
    }
    .r {
      flex: 1;
      .bgw {
        padding: 24px;
        min-height: 600px;
        border-radius: 6px;
        .article-nav {
          height: 30px;
          line-height: 30px;
          border-bottom: 1px dashed $border;
          margin-bottom: 20px;
          a.artlink {
            &:hover {
              color: $theme-color;
            }
          }
        }
        .top-head {
          font-size: 24px;
          font-weight: 400;
          line-height: 40px;
          color: #757575;
          margin-bottom: 10px;
          border-bottom: 1px solid rgb(238, 238, 238);
          .info {
            font-size: 14px;
            color: #76838f;
            span {
              margin-right: 10px;
              img {
                width: 15px;
                vertical-align: middle;
              }
            }
          }
        }
      }
      .art-list {
        li {
          padding: 10px;
          border-bottom: 1px solid rgb(238, 238, 238);
          margin-bottom: 20px;
          a {
            display: block;
            // padding: 10px;
            cursor: pointer;
            &:hover {
              color: $theme-color;
            }
          }
          .media {
            .media-left {
              width: 100px;
              height: 100px;
              display: inline-block;
              padding-right: 20px;
              vertical-align: top;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .media-body {
              display: inline-block;
              vertical-align: top;
              width: 700px;
              h4 {
                color: #333333;
                margin-bottom: 20px;
                font-size: 20px;
              }
              .des {
                font-size: 14px;
                margin-bottom: 20px;
                color: #76838f;
                line-height: 20px;
              }
              .info {
                font-size: 14px;
                color: #76838f;
                span {
                  margin-right: 10px;
                  img {
                    width: 15px;
                    vertical-align: middle;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
.recommendCover {
  display: inline-block;
  width: 50px;
  height: 50px;
  vertical-align: top;
  img {
    width: 50px !important;
  }
}
.recommendTitle {
  display: inline-block;
  width: 131px;
  margin-left: 5px;
}

.article-right {
            width: 300px;
            float: right;
            border-radius: 6px;
            // margin-top: 20px;
            font-size: 14px;
            .box {
                width: 260px;
                margin-bottom: 10px;
                padding: 0 20px;
                background: #fff;
                border-radius: 5px;
                h4 {
                    width: 300px;
                    margin-left: -20px;
                    height: 40px;
                    line-height: 40px;
                    border-bottom: 1px solid #e8e8e8;
                    border-radius: 5px 5px 0 0;
                    background: #ffffff;
                    background: linear-gradient(top, #ffffff, #f7f7f7);
                    strong {
                        display: block;
                        width: 122px;
                        margin-left: 15px;
                        color: #434a54;
                        font-weight: bold;
                        font-size: 14px;
                    }
                    .link {
                        float: right;
                        margin: -40px 20px 0 0;
                        color: #667ebd;
                        font-size: 12px;
                        cursor: pointer;
                    }
                }
                &.hot {
                    overflow: hidden;
                    ul {
                        width: 302px;
                        margin-left: -20px;
                        overflow: auto;
                        li {
                            float: left;
                            width: 150px;
                            height: 45px;
                            line-height: 45px;
                            border-bottom: 1px solid #eee;
                            border-right: 1px solid #eee;
                            background: #ffffff;
                            text-align: center;
                            &:hover {
                                color: #EA4B49;
                            }
                            &.more {
                                width: 300px;
                                float: left;
                                height: 45px;
                                line-height: 45px;
                                border-bottom: 1px solid #eee;
                                border-right: 1px solid #eee;
                                background: #ffffff;
                                text-align: center;
                                cursor: pointer;
                            }
                        }
                    }
                }
                &.choice{
                    .article {
                        line-height: 24px;
                        margin: 0 0 0 24px;
                        padding: 10px 0;
                        li {
                            padding: 4px 0 5px;
                            em {
                                float: left;
                                width: 14px;
                                height: 14px;
                                line-height: 14px;
                                margin: 3px 0 0 -24px;
                                border: 2px solid #aab2bd;
                                border-radius: 50%;
                                color: #aab2bd;
                                font-family: Tahoma,Verdana,sans-serif;
                                font-size: 10px;
                                text-align: center;
                                &.active {
                                    border: 2px solid #ff6600;
                                    color: #ff6600;
                                }
                            }
                            .link {
								margin:0px;
                                color: #595959;
                                overflow: hidden;
                                cursor: pointer;
								text-overflow: -o-ellipsis-lastline;
								overflow: hidden; 
								text-overflow: ellipsis; 
								display: -webkit-box; 
								-webkit-line-clamp: 3; 
								line-clamp: 3; 
								-webkit-box-orient: vertical
                            }
                        }
                    }
                }
                &.academy {
                    ul {
                        margin-top: 20px;
                        margin-left: -10px;
                        overflow: auto;
                        li {
                            float: left;
                            width: 125px;
                            height: 145px;
                            line-height: 18px;
                            margin-left: 10px;
                            .link {
                                color: #595959;
                                overflow: hidden;
                                cursor: pointer;
                                @include no-wrap-line(2);
                                img {
                                    width: 125px;
                                    height: 85px;
                                    display: block;
                                    margin: 0 0 12px;
                                    border-radius: 5px;
                                }
                            }
                        }
                    }
                }
            }
        }



.comment-list {
  margin-top: 20px;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  padding-bottom: 80px;
  float: left;
  width: 100%;
  box-sizing: border-box;
  .none-comment {
    font-size: 18px;
    color: #333;
  }
  &-item {
    position: relative;
    margin-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e6e6e6;
    float: left;
    width: 100%;
    .reply_list_img {
      float: left;
      img {
        width: 50px;
        height: 50px;
        display: block;
        border-radius: 50%;
      }
    }
    .reply_list_con {
      width: 780px;
      float: right;
      position: relative;
      // margin-left: 20px;
      .auth_msg {
        line-height: 20px;
        font-size: 12px;
        color: #8c8c8c;
        i {
          margin-right: 5px;
          font-size: 14px;
          color: #ff8b3d;
        }
      }
      .reply_txt {
        overflow: hidden;
        font-size: 16px;
        margin-top: 5px;
      }
    }
  }
}

.replay-action {
  margin-top: 20px;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  float: left;
  width: 100%;
  box-sizing: border-box;
  .el-textarea {
    margin-bottom: 20px;
  }
  .comment-list-item {
    border: none !important;
  }
}
</style>

<style lang="scss">
@import "@/assets/css/initial.scss";
</style>
